// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"fb3446d6","149":"d4b1f902","196":"06008270","335":"54cce063","421":"ea8c66b1","513":"05e536ca"}[chunkId] + ".chunk.js";
};